/* esm.sh - @radix-ui/react-navigation-menu@1.2.14 */
export * from "/*@radix-ui/react-navigation-menu@1.2.14/esnext/react-navigation-menu.mjs";
